import { Link } from "react-router-dom";

function BreadcrumbsProductDetails(props) {
  const categories = props.catagories || []; 
  

  return (
    <>
      <li>
        <Link to="/">Home</Link>
      </li>
      {categories.length > 0 && categories[0] && (
        <li>
          <Link to={`/category/${categories[0].slug}?category_product=${props?.categoryData?.child_slugs || ""}&orderBy=default`}>
            {categories[0].name}
          </Link>
        </li>
      )}
      {categories.length > 1 && categories[1] && (
        <li>
          <Link to={`/category/${categories[0].slug}?category_product=${categories[1].slug}&orderBy=default`}>
            {categories[1].name}
          </Link>
        </li>
      )}
      <li>{props.product || "No Product Name"}</li>
    </>
  );
}

export default BreadcrumbsProductDetails;
